/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TipoTrattamentoDTO
 */
export interface TipoTrattamentoDTO {
    /**
     * 
     * @type {number}
     * @memberof TipoTrattamentoDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TipoTrattamentoDTO
     */
    descrizione?: string | null;
}

/**
 * Check if a given object implements the TipoTrattamentoDTO interface.
 */
export function instanceOfTipoTrattamentoDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TipoTrattamentoDTOFromJSON(json: any): TipoTrattamentoDTO {
    return TipoTrattamentoDTOFromJSONTyped(json, false);
}

export function TipoTrattamentoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TipoTrattamentoDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
    };
}

export function TipoTrattamentoDTOToJSON(value?: TipoTrattamentoDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'descrizione': value.descrizione,
    };
}

